import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DepartamentoOrg, DepartamentoOrgUpdate } from '../interfaces/documento.interface';
import { CoreService } from 'src/app/shared/services/core-service.service';

@Injectable({providedIn: 'root'})
export class DepartamentoOrgService {
  private http = inject( HttpClient );
  private coreService = inject( CoreService );


  private baseUrl: string = environment.baseUrlAuth;


  getDepartOrg(): Observable<DepartamentoOrg[]>{
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.get<DepartamentoOrg[]>(`${this.baseUrl}/api/auth/deparatmentos`, { headers })
      .pipe(
        map((response: DepartamentoOrg[]) => response),
        catchError(err => {
          this.coreService.openErrorSnackbar(`Error al obtener la lista de departamentos: ${err.error.message}`, 'Ok');
          return throwError(() => err.error.message)
        })
    );
  }

  getDepartOrgActive(): Observable<DepartamentoOrg[]>{
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.get<DepartamentoOrg[]>(`${this.baseUrl}/api/auth/deparatmentos`, { headers })
      .pipe(
        map((response: DepartamentoOrg[]) => response.filter((departOrg: DepartamentoOrg) => departOrg.isActive === true)),
        catchError(err => {
          this.coreService.openErrorSnackbar(`Error al obtener la lista de departamentos: ${err.error.message}`, 'Ok');
          return throwError(() => err.error.message)
        })
    );
  }


  addDepartOrg(body: DepartamentoOrg): Observable<DepartamentoOrg[]>{
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });
    return this.http.post<DepartamentoOrg[]>(`${this.baseUrl}/api/auth/deparatmento`, body, { headers })
    .pipe(
      map((response: DepartamentoOrg[]) => response),
      catchError(err => {
        this.coreService.openErrorSnackbar(`Error al adicionar el departamento: ${err.error.message}`, 'Ok');
        return throwError(() => err.error.message)
      }
    ));
  }

  updateDepartOrg(id: string, body: DepartamentoOrgUpdate): Observable<DepartamentoOrgUpdate[]> {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });
    return this.http.put<DepartamentoOrgUpdate[]>(`${this.baseUrl}/api/auth/deparatmento?id=${id}`, body, { headers})
    .pipe(
      map((response: DepartamentoOrgUpdate[]) => response),
      catchError(err => {
        this.coreService.openErrorSnackbar(`Error al actualizar el departamento: ${err.error.message}`, 'Ok');
        return throwError(() => err.error.message)
      }
    ));
  }



}
